module.exports = __webpack_public_path__ + "img/H3.c4585e72.png";